import { lazy } from 'react';
import { authModules } from 'app/auth';
import ABSUtils from '@abs/utils/ABSUtils';
import themesConfig from 'app/configs/themesConfig';

const Tasks = lazy(() => import('./Tasks'));

const TasksConfig = {
	settings: {
		layout: {
			config: {}
		},
		theme: {
			main: ABSUtils.IsDarkMode() ? themesConfig.timeliteDark : themesConfig.timelite,
			navbar: ABSUtils.IsDarkMode() ? themesConfig.timeliteDark : themesConfig.timelite,
		}
	},
	routes: [
		{
			path: '/tl/tasks',
			element: <Tasks />,
			auth: authModules.tl_default
		}
	]
};

export default TasksConfig;

